//  For each product on the page
document.querySelectorAll('.product').forEach(section => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;


    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    const productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        // pagination: {
        //     el: section.querySelector('.swiper-pagination'),
        //     clickable: true,
        // },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        scrollbar: {
            el: section.querySelector(".swiper-scrollbar"),
            draggable: true,
        },
        on: {
            slideChange: function () {
                if (!section.querySelector(".productVisualSwiperSlide")) {
                    return;
                }

                // pause all videos
                section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    });

    /* Move the gallery to a variant's own image.
       Matches by FILENAME first and only falls back to featured_image.position:
       position indexes product.images, while the slides are built from
       product.media, and the two diverge the moment a video is added. Uses
       slideToLoop because the gallery runs in loop mode, where plain slideTo
       counts Swiper's rearranged order. Re-measures and retries once if the
       move did not take (images that were still loading leave Swiper unable
       to compute geometry). */
    function liveSwiper() {
        /* pdp-v2.js DESTROYS the instance created above and builds its own
           gallery (thumbnail rail + zoom), so the captured `productSwiper` is
           dead on the v2 template — calls against it fail silently, which is
           exactly why the price updated but the image never moved. Always
           read the instance currently attached to the element. */
        var root = section.querySelector(".productVisualSwiper");
        var sw = root && root.swiper ? root.swiper : productSwiper;
        return sw && !sw.destroyed ? sw : null;
    }

    function goToVariantImage(variant, speed) {
        if (!variant || !variant.featured_image) return;
        var sw = liveSwiper();
        if (!sw) return;
        /* Shopify inserts a size suffix BEFORE the extension
           (spearmint_40_ct_front_1000x.webp), so the rendered src never
           contains the raw filename — compare on the base name. */
        var file = String(variant.featured_image.src).split('?')[0].split('/').pop();
        var base = file.replace(/\.[a-z0-9]+$/i, "");
        var slides = section.querySelectorAll(".productVisualSwiperSlide");
        var idx = -1;
        for (var i = 0; i < slides.length; i++) {
            var im = slides[i].querySelector("img");
            if (im && String(im.getAttribute("src")).indexOf(base) > -1) { idx = i; break; }
        }
        if (idx < 0) idx = variant.featured_image.position - 1;
        if (idx < 0) return;
        var move = typeof sw.slideToLoop === "function" ? "slideToLoop" : "slideTo";
        sw[move](idx, speed);
        if (sw.realIndex !== idx) { sw.update(); sw[move](idx, 0); }
    }

    // open on the selected variant's image: ?variant= deep links select a
    // variant server-side, but the gallery would otherwise open on slide 1
    goToVariantImage(activeVariant, 0);

    /* ...and again once pdp-v2.js has swapped in its own gallery, which
       rebuilds at slide 0 and would otherwise discard the deep link. Watches
       for the instance to change rather than guessing at a delay; gives up
       after ~4s so a template without the enhancement costs nothing. */
    (function reapplyAfterGallerySwap() {
        var root = section.querySelector(".productVisualSwiper");
        if (!root) return;
        var first = root.swiper;
        var tries = 0;
        var timer = setInterval(function () {
            if (root.swiper && root.swiper !== first) {
                goToVariantImage(activeVariant, 0);
                clearInterval(timer);
            } else if (++tries > 40) {
                clearInterval(timer);
            }
        }, 100);
    })();

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // update active variant on input changes — DELEGATED to the section:
    // app embeds (selling-plan widgets) re-render the option inputs after
    // load, which silently kills listeners bound to the elements themselves
    section.addEventListener("change", function (e) {
        if (e.target.matches("input, select")) {
            updateProduct().catch(err => console.error(err));
        }
    })

    /**************
     Update Product
     ***************/

        // see if subscription box is active
    const subscriptionBox = document.querySelector('.productFormSelling');

    function isSubscription() {
        return !!document.querySelector(`.productFormSellingOptionHeaderInput[value="sub"]:checked`);
    }

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productFormOptionsItem:not(.mobileOnly)`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productATC").disabled = true;
            /* names the recovery, not just the state — this fires when the chosen
               combination does not exist, and the way out is picking another size */
            section.querySelector(".productATC").textContent = "Select another size";
            return;
        }

        /**************
         Variant Image
         ***************/

        goToVariantImage(activeVariant);

        /**************
         Price
         ***************/

            // if subscription turned off, skip
        const compare = section.querySelector(".productFormSellingOptionHeaderPriceCompare");
        const real = section.querySelector(".productFormSellingOptionHeaderPriceReal");
        const mainPrice = section.querySelector('.productPriceActual');
        const discountPrice = section.querySelector('.productPriceDiscount');
        if (subscriptionBox) {

            const allocationPrice = activeVariant.selling_plan_allocations[0].price;

            if (isSubscription()) {
                // Update with subscription prices
                if (activeVariant.price > allocationPrice) {
                    compare.textContent = price(activeVariant.price);
                    discountPrice.textContent = price(activeVariant.price);
                    discountPrice.style.display = "block";
                }
                real.textContent = price(allocationPrice);
                mainPrice.textContent = price(allocationPrice);
                compare.style.opacity = "1";
            } else {
                // Update with one-time purchase prices
                if (activeVariant.compare_at_price > activeVariant.price) {
                    compare.textContent = price(activeVariant.compare_at_price);
                    discountPrice.textContent = price(activeVariant.compare_at_price);
                    discountPrice.style.display = "block";
                }
                real.textContent = price(activeVariant.price);
                mainPrice.textContent = price(activeVariant.price);
                compare.style.opacity = "0";
                discountPrice.style.display = "none";
            }

            /* The VISIBLE card figures are our own spans; the legacy spans this
               block writes are kept hidden (see the Liquid comment). Both cards
               were server-rendered for the first variant and never refreshed —
               Hannah caught them frozen at the 40ct prices with 100ct selected
               while the ATC updated correctly. Refresh them from the same data
               this function already holds. The saving is derived from the
               allocation Shopify actually charges, never recomputed from the
               percentage — allocations are rounded per-variant and a recompute
               can drift a cent. */
            var oncePrice = section.querySelector('[data-once-price]');
            if (oncePrice) oncePrice.textContent = price(activeVariant.price);
            var subReal = section.querySelector('.pdpSubReal');
            if (subReal) subReal.textContent = price(allocationPrice);
            var subCompare = section.querySelector('.pdpSubCompare');
            if (subCompare) subCompare.textContent =
                activeVariant.price > allocationPrice ? price(activeVariant.price) : '';
            var subSave = section.querySelector('[data-sub-save]');
            if (subSave) {
                var subDiff = activeVariant.price - allocationPrice;
                /* count only from an explicit "N Ct" title. A bare digit-grab would turn a
               loose-leaf "8 oz" variant into a nonsense "$1.59 per cup" when this
               template rolls out to other SKUs. No match -> the line still shows the
               saving, just without per-cup. */
            var ctMatch = String(activeVariant.title).match(/(\d+)\s*ct\b/i);
                var subCup = ctMatch ? (allocationPrice / 100 / parseInt(ctMatch[1], 10)) : null;
                subSave.textContent = subDiff > 0
                    ? 'Save ' + price(subDiff) + (subCup ? ' · $' + subCup.toFixed(2) + ' per cup' : '')
                    : '';
            }
        } else {
            mainPrice.textContent = price(activeVariant.price);
            discountPrice.textContent = activeVariant.compare_at_price > activeVariant.price ? price(activeVariant.compare_at_price) : "";
        }


        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productATC").disabled = false;
            section.querySelector(".productATC").textContent = "Add To Cart";
        } else {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATC").textContent = "Sold Out";
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(err => console.error(err));

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelectorAll(".productQuantityControlsBtn.minus")?.forEach(el => el.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelectorAll(".productQuantityControlsValue").forEach(el => el.textContent = String(quantity));
        updateProduct().catch(err => console.error(err));
    }));

    // plus
    section.querySelectorAll(".productQuantityControlsBtn.plus")?.forEach(el => el.addEventListener("click", function () {
        quantity++;
        section.querySelectorAll(".productQuantityControlsValue").forEach(el => el.textContent = String(quantity));
        updateProduct().catch(err => console.error(err));
    }));


    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = parseInt(section.querySelector('.productFormSellingOptionPlan').value)
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productATC").classList.remove("loading");

        // open cart
        // DELIBERATELY DISABLED. Production runs a third-party cart app that
        // opens its own drawer on add to cart. Calling openCart() here opens
        // the theme's native mini-cart as well, so the customer gets two
        // carts stacked on each other.
        //
        // It was briefly enabled during sandbox work because the sandbox has
        // no cart app installed, so add to cart appeared to do nothing there.
        // That was a sandbox-only symptom. Leave this commented out.
        // await openCart();
        //
        // SANDBOX ONLY (16 Aug 2026): FGO_NATIVE_DRAWER is set in
        // theme-mini-cart.js exclusively on sandbox domains, so the line
        // below is inert on production and the rule above still holds.
        // It exists so the cart flow can be previewed and QA'd on sandbox.
        if (window.FGO_NATIVE_DRAWER && typeof openCart === "function") await openCart();
    }

    section.querySelector('.productATC').addEventListener("click", addToCart);

    // setup dropdowns
    section.querySelectorAll(".productDropdownsItemButton").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });
});
/**************
 Docked buy bar  (pdp-v2)
 ***************

 Owns no cart logic. It forwards a click to the real .productATC, so variant,
 quantity, selling plan, the Upcart drawer and the Sold Out / Not Available
 states all run through the code that is already tested. A second cart path on
 this surface is how the double-drawer bug happened; there is exactly one.

 The label and disabled state are MIRRORED, not recomputed. Two different
 scripts write that button — the theme's (Add To Cart / Sold Out / Not
 Available) and pdp-v2's price-in-label pass — so observing it is the only way
 to stay correct without betting on which one ran last.
 ***************/
(function () {
    var bar = document.querySelector('[data-buy-bar]');
    if (!bar) return;

    var realAtc = document.querySelector('.productATC');
    var barBtn  = bar.querySelector('[data-buy-bar-atc]');
    var barMeta = bar.querySelector('[data-buy-bar-meta]');
    if (!realAtc || !barBtn) return;

    /* ---- mirror label + disabled state ---- */
    function sync() {
        var label = (realAtc.textContent || '').trim();
        if (label) barBtn.textContent = label;
        barBtn.disabled = realAtc.disabled;
        /* The price is NOT in textContent. pdp-v2.js renders it through a
           ::after fed by --atc-price, precisely because the theme rewrites
           this button with textContent on every variant change and that would
           destroy a child span. So mirror the custom property and let the same
           mechanism draw it here. */
        barBtn.style.setProperty('--atc-price',
            realAtc.style.getPropertyValue('--atc-price') || '""');
        var picked = document.querySelector('[data-purchase-pick]');
        var size   = document.querySelector('.productFormOptionsItemValuesLabelInput:checked');
        var parts  = [];
        if (size && size.value) parts.push(size.value);
        if (picked && picked.textContent.trim()) parts.push(picked.textContent.trim());
        if (barMeta && parts.length) barMeta.textContent = parts.join(' \u00B7 ');
    }
    sync();

    if ('MutationObserver' in window) {
        new MutationObserver(sync).observe(realAtc, {
            childList: true, characterData: true, subtree: true, attributes: true,
            /* 'style' so the --atc-price custom property rides along — the bar
               copied it once at bind, before pdp-v2.js had set it, so the bar
               button showed no price */
            attributeFilter: ['disabled', 'style']
        });
    }
    setTimeout(sync, 400);   /* catch the late first --atc-price write */
    /* the variant/purchase radios do not touch .productATC's text, so the meta
       line needs its own trigger */
    document.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') setTimeout(sync, 0);
    });

    /* ---- one cart path ---- */
    barBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (barBtn.disabled) return;
        realAtc.click();
    });

    /* ---- show once the real button is off screen ---- */
    function setVisible(on) {
        bar.classList.toggle('is-in', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        /* keep it out of the tab order entirely while hidden — a focusable
           control behind an invisible bar is a keyboard trap */
        barBtn.setAttribute('tabindex', on ? '0' : '-1');
    }

    if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                /* only dock once the button has scrolled UP out of view. Below
                   the fold on first load is not a reason to cover the page. */
                var below = entry.boundingClientRect.top > 0;
                setVisible(!entry.isIntersecting && !below);
            });
        }, { threshold: 0, rootMargin: '0px' }).observe(realAtc);
    } else {
        /* no observer: leave it off rather than pin a bar that never hides */
        setVisible(false);
    }
}());
